<template>
  <div>
    <mdb-select :disabled="disabled" :icon="icon"
                :label="label"
                @getValue="valueChanged"
                class="gp-mdb-select-parent"
                :required="required"
                :resetBtn="!required"
                ref="validationSelect" :placeholder="placeholder"
                v-model="possibleValues" validation/>
  </div>
</template>

<script>
/*This component is only needed to make the  MDB selects work with data binding the way you'd expect, not the way
 it does.
 */
import {mdbSelect} from 'mdbvue';

export default {
    name: 'GPSelect',
    components: {
      mdbSelect
    },
    data() {
      return {
        isValid: true,
        basicOptions: [
          {text: 'Option nr 1', value: 'Option 1'},
          {text: 'Option nr 2', value: 'Option 2'},
          {text: 'Option nr 3', value: 'Option 3'}
        ]
      }
    },
    props: {
      dataObj: {
        type: Object,
        default: null
      },
      propertyName: {
        type: String,
        default: null
      },
      possibleValues: {
        type: Array,
        default: []
      },
      label: {
        type: String,
        default: ""
      },
      required: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      icon: {
        type: String,
        default: ""
      },
      placeholder: {
        type: String,
        default: ""
      }
    },
    beforeMount() {
      for (let i = 0; i < this.possibleValues.length; i++) {
        let row = this.possibleValues[i]
        if (row.value == this.dataObj[this.propertyName]) {
          row.selected = true
        } else row.selected = false
      }
    },
    mounted() {
      let inputElement = document.querySelector('.gp-mdb-select-parent > div> form > div > input.form-control');
      if (inputElement) {
        inputElement.setAttribute("readonly", true)
      }
    },
    methods: {
      valueChanged: function (value, text) {
        this.dataObj[this.propertyName] = value;
        this.$emit("valueChanged", value)
      }
    }
  };
</script>
